import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../services/utils';

import { useAuthState } from '../../contexts/AuthContext';

import Logo from '../Shared/Logo';
import InfoBar from './InfoBar';
import SiteNavigation from './SiteNavigation';
import UserMenu from './UserMenu';

import styles from './header.module.css';

const Header = ( {
	className,
	navigation = 'internal',
	OverrideRight
} ) => {
	const { user } = useAuthState();

	return (
		<header className={ className }>
			{ log( 'header' ) }
			<div className={ styles.header }>
				<Logo className={ styles.logo } labelled />
				{ navigation === 'internal'
					? <SiteNavigation />
					: null
				}
				{ OverrideRight
					? <OverrideRight />
					: user
						? <UserMenu />
						: null
				}
			</div>
			<InfoBar title="Operations" />
		</header>
	);
};

Header.propTypes = {
	className: PropTypes.string,
	navigation: PropTypes.oneOf( [
		'internal',
		'external'
	] ),
	OverrideRight: PropTypes.node
};

export default memo( Header );
